var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M204.379 93.5806C204.379 114.725 197.285 134.331 185.398 150.093C178.879 158.551 171.019 166.047 162.008 171.814C147.437 181.425 129.99 186.999 111.201 186.999C59.6266 186.807 17.8306 144.903 17.8306 93.5806C17.8306 41.8737 59.6266 0.162109 111.009 0.162109C129.798 0.162109 147.245 5.73646 161.816 15.1552C170.827 20.9218 178.688 28.4183 185.206 36.876C197.285 52.6379 204.379 72.2443 204.379 93.5806Z",
  fill: "#282C35"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.25932 104.345C4.98485 104.345 6.51865 102.999 6.51865 101.077C6.51865 99.3473 5.17657 97.8096 3.25932 97.8096C1.34207 98.0018 0 99.3473 0 101.27C0 102.999 1.34207 104.345 3.25932 104.345Z",
  fill: "url(#paint0_linear_1902_7970)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M22.6241 175.275C24.3496 175.275 25.8834 173.929 25.8834 172.007C25.8834 170.277 24.5413 168.739 22.6241 168.739C20.8985 168.739 19.3647 170.085 19.3647 172.007C19.5565 173.929 20.8985 175.275 22.6241 175.275Z",
  fill: "url(#paint1_linear_1902_7970)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M65.0229 141.917C67.3178 141.917 69.3577 140.132 69.3577 137.582C69.3577 135.287 67.5728 133.247 65.0229 133.247C62.7279 133.247 60.688 135.032 60.688 137.582C60.943 140.132 62.7279 141.917 65.0229 141.917Z",
  fill: "url(#paint2_linear_1902_7970)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M198.681 35.1898C201.557 32.4988 201.749 28.0777 199.065 25.1944C196.381 22.3112 191.971 22.1189 188.903 24.81C186.028 27.5011 185.836 31.9221 188.52 34.8054C191.204 37.6887 195.614 37.8809 198.681 35.1898Z",
  fill: "#282C35"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M172.682 14.5514C174.407 14.5514 175.749 13.2059 175.749 11.4759C175.749 9.74593 174.407 8.40039 172.682 8.40039C170.956 8.40039 169.614 9.74593 169.614 11.4759C169.614 13.2059 170.956 14.5514 172.682 14.5514Z",
  fill: "url(#paint3_linear_1902_7970)"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_1902_7970)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.0246 111.051L156.082 151.806C161.99 153.701 168.135 150.384 170.026 144.46L193.896 66.2683C195.786 60.3446 192.478 54.184 186.569 52.2885L53.2757 11.5338C47.3673 9.63825 41.2225 12.9555 39.3318 18.8791L15.4619 97.0712C13.8075 102.995 17.1162 109.392 23.0246 111.051Z",
  fill: "url(#paint4_linear_1902_7970)"
}));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M165.536 133.085C165.299 133.085 165.063 133.085 164.827 133.085L118.268 118.869C117.087 118.395 116.378 117.21 116.614 116.025C117.087 114.841 118.268 114.13 119.45 114.367L166.008 128.583C167.19 129.057 167.899 130.242 167.663 131.427C167.426 132.375 166.481 133.085 165.536 133.085Z",
  fill: "url(#paint5_linear_1902_7970)"
});

var _ref0 = /*#__PURE__*/React.createElement("path", {
  d: "M160.1 115.788C159.863 115.788 159.627 115.788 159.391 115.788L104.088 98.728C102.906 98.2541 102.197 97.0694 102.433 95.8847C102.906 94.7 104.088 93.9891 105.27 94.2261L160.572 111.286C161.754 111.76 162.463 112.945 162.227 114.13C161.99 115.077 161.045 115.788 160.1 115.788Z",
  fill: "url(#paint6_linear_1902_7970)"
});

var _ref1 = /*#__PURE__*/React.createElement("path", {
  d: "M77.3825 89.7258C77.8551 89.7258 78.0915 89.7258 78.5641 89.4888C79.9822 88.778 80.9275 87.1194 80.2185 85.6977C79.0368 82.3805 78.8005 78.8263 79.9822 75.509C81.1638 72.1918 83.2909 69.3484 86.1269 67.4529C87.5449 66.5051 87.7813 64.6095 87.0723 63.4248C86.1269 62.0031 84.2362 61.7662 83.0545 62.477C79.0368 65.0834 75.9644 69.1115 74.5464 73.8504C73.1284 78.5893 73.1284 83.5652 75.0191 88.0672C75.2554 89.0149 76.2008 89.7258 77.3825 89.7258Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M65.565 95.8861C66.0377 95.8861 66.274 95.8861 66.7467 95.6491C68.1647 94.9383 68.8737 93.2797 68.1647 91.621C65.3287 85.2235 64.856 77.8782 66.983 71.2437C69.11 64.6092 73.6004 58.9226 79.7452 55.3684C81.1632 54.4206 81.6359 52.762 80.6905 51.3403C79.7452 49.9186 78.0908 49.4447 76.6728 50.3925C69.3464 54.6575 63.9106 61.529 61.3109 69.5851C58.7112 77.6413 59.1839 86.4082 62.729 94.2274C63.2016 95.4122 64.3833 95.8861 65.565 95.8861Z",
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M54.2202 101.81C54.6929 101.81 55.1656 101.81 55.4019 101.573C56.8199 100.862 57.5289 99.2038 56.8199 97.5452C52.5659 88.0673 51.8568 77.4048 54.9292 67.4531C58.0016 57.5013 64.8553 49.2082 73.8361 43.9954C75.2541 43.2846 75.7268 41.389 75.0178 39.9674C74.3088 38.5457 72.4181 38.0718 71.0001 38.7826C60.6013 44.7063 53.0385 54.1841 49.4935 65.5575C45.9484 76.9309 46.6574 89.0151 51.6205 99.9146C52.0932 101.099 53.2749 101.81 54.2202 101.81Z",
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M173.467 79.0307C175.287 73.157 172.014 66.916 166.155 65.0912C160.296 63.2663 154.071 66.5486 152.251 72.4223C150.431 78.296 153.705 84.5369 159.564 86.3618C165.422 88.1867 171.647 84.9044 173.467 79.0307Z",
  fill: "#2767F4"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M148.755 82.3813C154.89 82.3813 159.863 77.3953 159.863 71.2448C159.863 65.0944 154.89 60.1084 148.755 60.1084C142.621 60.1084 137.647 65.0944 137.647 71.2448C137.647 77.3953 142.621 82.3813 148.755 82.3813Z",
  fill: "url(#paint7_linear_1902_7970)"
});

var _ref14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_1902_7970",
  x: 5.17514,
  y: 7.30195,
  width: 199.115,
  height: 161.063,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 6.16342
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.93074
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1902_7970"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1902_7970",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1902_7970",
  x1: 0,
  y1: 101.204,
  x2: 6.1977,
  y2: 101.204,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#83A6FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5A78FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_1902_7970",
  x1: 19.4978,
  y1: 172.096,
  x2: 25.6955,
  y2: 172.096,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF66A9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F53689"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_1902_7970",
  x1: 60.865,
  y1: 137.7,
  x2: 69.1078,
  y2: 137.7,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF66A9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F53689"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_1902_7970",
  x1: 169.689,
  y1: 11.4849,
  x2: 175.51,
  y2: 11.4849,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#83A6FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5A78FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_1902_7970",
  x1: 15.1369,
  y1: 81.7418,
  x2: 194.33,
  y2: 81.7418,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#83A6FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5A78FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_1902_7970",
  x1: 116.592,
  y1: 123.463,
  x2: 167.922,
  y2: 123.463,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BDCFFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#91A5FF",
  stopOpacity: 0.5
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_1902_7970",
  x1: 102.371,
  y1: 104.98,
  x2: 162.44,
  y2: 104.98,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BDCFFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#91A5FF",
  stopOpacity: 0.5
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_1902_7970",
  x1: 137.799,
  y1: 71.2868,
  x2: 159.811,
  y2: 71.2868,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BDCFFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#91A5FF",
  stopOpacity: 0.5
})));

function SvgEmptyCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 187,
    viewBox: "0 0 205 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref0, _ref1, _ref10, _ref11, _ref12, _ref13, _ref14);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCard);
export default __webpack_public_path__ + "static/media/empty-card.003e0847392dccaad237120801def55f.svg";
export { ForwardRef as ReactComponent };